<template>
<div class="v-cloak">
    <!-- CSS from public/index.html -->
  <div id="loading"></div>
</div>
</template>

<script>
export default {
  name: 'BoxLoadingSpinner',
}
</script>
